<template>
    <div class="member-table">
        <el-input
            v-model="search"
            size="small"
            class="table-search"
            @keyup.native.enter="handleSearch(search)"
            @input="handleInput"
            :placeholder="$t('public.keyWord')"
            clearable>
        </el-input>
        <el-table
            :data="member_list"
            :default-sort="{prop: '', order: ''}"
            height="300"
            @sort-change="handleTableSort"
            @selection-change="handleSelectionChange">
            <el-table-column
                type="selection"
                width="44">
            </el-table-column>
            <!-- 用户ID -->
            <el-table-column
                :label="$t('message.cmember.table1')"
                prop="user_id"
                align="center"
                width="160px"
                sortable="custom"
                show-overflow-tooltip>
            </el-table-column>
            <!-- 登录名 -->
            <el-table-column
                :label="$t('message.cmember.table2')"
                prop="username"
                align="center"
                sortable="custom"
                show-overflow-tooltip>
            </el-table-column>
            <!-- 等级 -->
            <el-table-column
                :label="$t('message.cmember.table3')"
                prop="charactername"
                align="center"
                sortable="custom"
                show-overflow-tooltip>
            </el-table-column>
            <!-- 分公司 -->
            <el-table-column
                label="分行/分公司"
                prop="branchname"
                align="center"
                sortable="custom"
                show-overflow-tooltip>
            </el-table-column>
			<!-- 部门名称 -->
			<el-table-column
			    :label="$t('message.cmember.table5')"
			    prop="departmentname"
			    align="center"
			    sortable="custom"
			    show-overflow-tooltip>
			</el-table-column>
            <!-- 部门编码 -->
            <el-table-column
                :label="$t('message.cmember.table4')"
                prop="department_code"
                align="center"
                sortable="custom"
                show-overflow-tooltip>
            </el-table-column>
			<!-- 分配總額度 -->
			<el-table-column
			    :label="$t('message.cmember.table7')"
			    prop="amount"
			    align="center"
			    sortable="custom"
			    show-overflow-tooltip>
			</el-table-column>
        
            <!-- 操作 -->
            <el-table-column
                :label="$t('message.cmember.table6')"
                align="center"
                width="150">
                <template v-slot="{row}">
                    <el-button
                        type="primary"
                        size="mini"
                        @click="handleModify(row.id)">
                        <span>{{$t("public.modifyBtn")}}</span>
                    </el-button>
                    <el-button
                        type="danger"
                        size="mini"
                        @click="handleDel(row.id)">
                        <span>{{$t("public.delBtn")}}</span>
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
     <table-pagination
            :current-page="page2.current_page"
            :page-count="page2.last_page"
            :need-export="true"
            :need-del="true"
            @handle-export="handleExport"
            @handle-del="handleBatchDel"
            @current-change="handleCurrent">	
        </table-pagination>
		<div style="padding: 10px; display: flex;justify-content: flex-end;">
			<el-pagination
			  @current-change="handleCurrent"
			  :current-page.sync="currentPage2"
			  :page-size="page2.per_page"
			  layout="prev, pager, next, jumper"
			  :total="page2.total"
			  background>
			</el-pagination>
		</div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { tableSortHandle } from "@/utils/publicMethod.js";

export default {
    mixins: [ tableSortHandle ],
    computed: mapState({
        member_list: state => state.user.member_list,
		page2: state => state.user.page2,
    }),
	data() {
		return {
			currentPage2:0,
		}
	},
	watch:{
		currentPage(){
			this.currentPage2 = this.currentPage
		}
	},
    methods: {
        ...mapActions([
            "handleDelMember",
        ]),
        handleDel(id){ // 删除按钮
            this.$confirm(this.$t("message.cmember.isDel"),{
                confirmButtonText: this.$t("public.confirmBtn"),
                cancelButtonText: this.$t("public.cancelBtn"),
                type: 'warning'
            }).then(() => this.handleDelMember(id))
            .then(res => {
                this.$emit('handleDelete', res)
            }).catch(() => {})
        },
        handleExport() {
            this.$emit('handle-export')
        }
    }
}
</script>

<style scoped>
.member-table{
    background: #fff;
}
.table-search{
    width: 200px;
    margin: 10px;
}
</style>